import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const tagsApi = createApi({
  reducerPath: "tagsApi",
  baseQuery: customFetchBase,
  tagTypes: ["tags"],
  endpoints: () => ({}),
});
